import React from 'react'
import cx from 'classnames'
import styles from './Pill.sass'

interface PillProps {
  children?: React.ReactNode
  shape?: 'square' | 'pill'
  trim?: boolean
  stout?: boolean
  color?: 'grey' | 'red'
  title?: string
  ['data-test']?: string
}

export default function Pill({
  children,
  shape = 'pill',
  trim,
  stout,
  color = 'grey',
  title,
  'data-test': dataTest,
}: PillProps) {
  return (
    <div
      data-test={dataTest}
      className={cx(
        styles.default,
        styles[color],
        styles[shape],
        trim && styles.trim,
        stout && styles.stout,
      )}
      title={title}
    >
      {children}
    </div>
  )
}
